import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-greenDark grain flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <div className="bg-brand-cream rounded-3xl p-9 shadow-2xl">
          <div className="flex justify-center mb-8">
            <Logo />
          </div>
          <div className="text-center mb-7">
            <div className="w-12 h-12 rounded-full bg-brand-green/10 flex items-center justify-center mx-auto mb-4">
              <Lock size={22} className="text-brand-green" />
            </div>
            <h1 className="font-serif text-2xl text-brand-green">Admin Login</h1>
            <p className="text-brand-green/60 text-sm mt-1">Manage treatments, bookings & settings</p>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" data-testid="admin-email-input" value={email}
                onChange={(e) => setEmail(e.target.value)} className="mt-1.5" placeholder="you@email.com" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" data-testid="admin-password-input" value={password}
                onChange={(e) => setPassword(e.target.value)} className="mt-1.5" placeholder="••••••••" />
            </div>
            {error && <p className="text-destructive text-sm" data-testid="admin-login-error">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full bg-brand-green text-white rounded-full py-3 font-medium hover:bg-brand-greenDark transition-all disabled:opacity-50"
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
        <button onClick={() => navigate("/")} className="w-full text-center text-brand-cream/60 text-sm mt-5 hover:text-brand-cream" data-testid="admin-back-home">
          ← Back to website
        </button>
      </div>
    </div>
  );
}
